import { render, staticRenderFns } from "./AddCorporateVendorModal.vue?vue&type=template&id=1007c43f"
import script from "./AddCorporateVendorModal.vue?vue&type=script&lang=js"
export * from "./AddCorporateVendorModal.vue?vue&type=script&lang=js"
import style0 from "./AddCorporateVendorModal.vue?vue&type=style&index=0&id=1007c43f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports